import { Injectable, inject } from '@angular/core';
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpContext,
} from '@angular/common/http';
import { UtilityService } from './utility.service';
import { SKIP_GLOBAL_SPINNER } from '../interceptors';

@Injectable({
  providedIn: 'root',
})
export class BaseHttpService {
  protected http = inject(HttpClient);
  protected utilityService = inject(UtilityService);

  protected createParams(
    params: Record<string, string | number | boolean>,
  ): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined) {
        httpParams = httpParams.append(key, params[key]);
      }
    });
    return httpParams;
  }

  protected createHeaders(
    additionalHeaders?: Record<string, string>,
  ): HttpHeaders {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    if (additionalHeaders) {
      Object.keys(additionalHeaders).forEach((key) => {
        headers = headers.append(key, additionalHeaders[key]);
      });
    }

    return headers;
  }

  /**
   * Standard HTTP request method
   * @param url The API endpoint URL
   * @param payload Optional request payload
   * @param additionalHeaders Optional additional headers
   * @param queryParams Optional query parameters
   */
  sendRequest<R>(
    url: string,
    payload?: Record<string, string | number | boolean | unknown>,
    additionalHeaders?: Record<string, string>,
    queryParams?: Record<string, string | number | boolean>,
    shouldSkipGlobalSpinner = false,
  ) {
    const httpOptions = {
      headers: this.createHeaders(additionalHeaders),
      context: shouldSkipGlobalSpinner
        ? new HttpContext().set(SKIP_GLOBAL_SPINNER, true)
        : undefined,
      params: queryParams ? this.createParams(queryParams) : undefined,
    };

    let response;
    if (payload && !this.utilityService.isObjectEmpty(payload)) {
      response = this.http.post<R>(url, payload, httpOptions);
    } else {
      response = this.http.get<R>(url, httpOptions);
    }
    return response;
  }
}
